import { MenuItem, Select } from "@mui/material";
import { FundingRound } from "@prisma/client";
import React from "react";
import { formatFundingRounds } from "~/services/funding";

type Event = {
  target: {
    value: string | string[];
  };
};

type Props = {
  disabled?: boolean;
  multiple?: boolean;
  name?: string;
  onChange: (event: Event) => void;
  value: FundingRound[];
};

const Groups: FundingRound[][] = [
  [FundingRound.PRE_SEED],
  [FundingRound.SEED],
  [FundingRound.SERIES_A],
  [FundingRound.SERIES_B],
  [FundingRound.SERIES_C, FundingRound.SERIES_D, FundingRound.SERIES_E],
  [FundingRound.POST_ACQUISITION],
  [FundingRound.POST_IPO],
  [FundingRound.SELF_FINANCED],
];

export const LegacyCompanyFundingRoundSelector: React.FC<Props> = ({
  disabled = false,
  multiple = false,
  name,
  onChange,
  value,
}) => {
  const groupedValue = Groups.filter((group) => {
    return group.every((round) => {
      return value.includes(round);
    });
  }).map((group) => {
    return group.join(",");
  });

  return (
    <Select
      size="small"
      multiple={multiple}
      className="h-7 bg-white text-sm"
      disabled={disabled}
      name={name}
      placeholder="Latest funding rounds"
      value={groupedValue}
      onChange={onChange}
    >
      {Groups.map((group) => {
        const itemValue = group.join(",");

        return (
          <MenuItem value={itemValue} key={itemValue}>
            {formatFundingRounds(group)}
          </MenuItem>
        );
      })}
    </Select>
  );
};
